import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ReservationEvent, ReservationEventType } from './reservation-event';

@Injectable()
export class ReservationEventService {
  eventHandler: Subject<ReservationEvent> = new Subject();

  constructor() {}

  rideRequestCreated() {
    const reservationEvent = new ReservationEvent();
    reservationEvent.eventType = ReservationEventType.RideRequestCreated;
    this.eventHandler.next(reservationEvent);
  }

  rideRequestUpdated() {
    const reservationEvent = new ReservationEvent();
    reservationEvent.eventType = ReservationEventType.RideRequestUpdated;
    this.eventHandler.next(reservationEvent);
  }

  rideRequestCancelled() {
    const reservationEvent = new ReservationEvent();
    reservationEvent.eventType = ReservationEventType.RideRequestCancelled;
    this.eventHandler.next(reservationEvent);
  }

  driverSelected() {
    const reservationEvent = new ReservationEvent();
    reservationEvent.eventType = ReservationEventType.DriverSelected;
    this.eventHandler.next(reservationEvent);
  }

  favoriteLocationSelected() {
    const reservationEvent = new ReservationEvent();
    reservationEvent.eventType = ReservationEventType.FavoriteLocationSelected;
    this.eventHandler.next(reservationEvent);
  }

  reservationCancelled() {
    const reservationEvent = new ReservationEvent();
    reservationEvent.eventType = ReservationEventType.ReservationCancelled;
    this.eventHandler.next(reservationEvent);
  }

  detailsClosed() {
    const reservationEvent = new ReservationEvent();
    reservationEvent.eventType = ReservationEventType.DetailsClosed;
    this.eventHandler.next(reservationEvent);
  }
}
